import Layout from '@/layout/index.vue';
import { taxSubMenu } from './subMenus/tax-sub-menu';
import { locationSubMenu } from './subMenus/location-sub-menu';
import bannerRouter from './subMenus/banner-sub-menu';
import { companiesSubMenu } from './subMenus/companies-sub-menu';
import { cashDiscountsSubMenu } from './subMenus/cash-discount-sub-menu';
import branchRouter from './subMenus/branches-sub-menu';
const masterRouter = {
  path: '/masters',
  component: Layout,
  redirect: 'noredirect',
  name: 'Masters',
  meta: {
    roles: ['Super Admin', 'Admin', 'Product Manager'],
    title: 'master.title',
    icon: 'star'
  },
  children: [...bannerRouter, ...taxSubMenu, ...companiesSubMenu, ...locationSubMenu, ...cashDiscountsSubMenu, ...branchRouter]
};
export default masterRouter;